import { all } from "redux-saga/effects";

// Action types
import * as types from "../actionTypes/manager.types";

// Actions
import {
  addNewManagerSuccess,
  getManagersSuccess,
  updateManagerSuccess,
  deleteManagerSuccess
} from "../actions/managers.actions";

// Calls
import {
  createManagerRequest,
  fetchManagersRequest,
  updateManagerRequest,
  deleteManagersRequest
} from "../../api/calls/manager.call";

import { fetchSaga } from "./fetch.saga";

export default function* managerSaga() {
  yield all([
    fetchSaga({
      trigger: types.ADD_MANAGER_REQUEST,
      apiCall: createManagerRequest,
      args: a => [a.managerFormValues],
      onSuccess: r => addNewManagerSuccess(r.managers),
      failedType: types.ADD_MANAGER_FAILED
    })(),
    fetchSaga({
      trigger: types.FETCH_MANAGERS_REQUEST,
      apiCall: fetchManagersRequest,
      onSuccess: r => getManagersSuccess(r.managers),
      failedType: types.FETCH_MANAGERS_FAILED
    })(),
    fetchSaga({
      trigger: types.UPDATE_MANAGER_REQUEST,
      apiCall: updateManagerRequest,
      args: a => [a.managerFormValues, a.initialValues, a.id],
      onSuccess: r => updateManagerSuccess(r.managers),
      failedType: types.UPDATE_MANAGER_FAILED
    })(),
    fetchSaga({
      trigger: types.DELETE_MANAGER_REQUEST,
      apiCall: deleteManagersRequest,
      args: a => [a.id],
      onSuccess: r => deleteManagerSuccess(r.managers),
      failedType: types.DELETE_MANAGER_FAILED
    })()
  ]);
}
